module.exports = __webpack_public_path__ + "static/media/11.a2b946f4.gif";